import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero" style={{ backgroundImage: 'url(/arp3-logo.png)' }}>
    </section>
  );
};

export default Hero;
